import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { useSEO } from "@/hooks/useSEO";

// Import the sightings data from the correct location
import { sightings } from "@/data/sightingsData";

const SightingDetail = () => {
  const { id } = useParams();
  
  // Find the sighting with the matching ID
  const sighting = sightings.find(s => s.id === id);

  useSEO({
    title: sighting ? `${sighting.title} | Loch Ness Story` : "Sighting Not Found | Loch Ness Story",
    description: sighting ? sighting.description.slice(0, 160) : "This sighting could not be found.",
    canonical: id ? `/sightings/${id}` : undefined,
    ogImage: sighting?.image || "/lovable-uploads/74638626-9ce3-4018-94b3-ec8980da02b9.png",
    ogType: "article",
  });

  if (!sighting) {
    return (
      <div className="min-h-screen bg-background">
        <Navbar />
        <div className="container mx-auto px-4 py-16">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-4 text-foreground">Sighting not found</h1>
            <p className="text-muted-foreground mb-8">The sighting you're looking for doesn't exist.</p>
            <Link to="/blog">
              <Button variant="outline">
                Return to Articles
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-16">
        <article className="max-w-4xl mx-auto">
          <header className="mb-8">
            <div className="flex gap-2 mb-4">
              {sighting.categories.map((category) => (
                <span
                  key={category}
                  className="text-xs font-medium tracking-wide uppercase px-2 py-0.5 bg-secondary text-muted-foreground rounded"
                >
                  {category}
                </span>
              ))}
            </div>
            <h1 className="text-4xl font-bold mb-4 text-foreground">{sighting.title}</h1>
            <div className="text-muted-foreground">
              <time dateTime={sighting.date}>{sighting.date}</time>
            </div>
          </header>

          <div className="aspect-w-16 aspect-h-9 mb-8 rounded-lg overflow-hidden">
            <img
              src={sighting.image}
              alt={sighting.title}
              className="object-cover w-full h-full"
            />
          </div>

          <div className="prose prose-invert max-w-none">
            <p className="text-muted-foreground leading-relaxed whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: sighting.description }} />
          </div>

          <div className="mt-12">
            <Link to="/blog">
              <Button variant="outline">
                ← Back to Articles
              </Button>
            </Link>
          </div>
        </article>
      </main>
    </div>
  );
};

export default SightingDetail;